import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AccountService } from './custom/account.service';
import { Famiglia } from '../interfaces/custom/famiglia';
import { Card } from '../interfaces/card-list-menu';
import { Articolo, ArticoloFull } from '../interfaces/custom/articolo';
import { StoreService } from './store.service';


declare var api_base_url;

@Injectable({ providedIn: 'root', })
export class ServizioMenuService {

  searchProduct(query: string, extra_params?: { [key: string]: string | number }): Observable<Articolo[]> {
  if (!query) {
    return of([]);
  }

  const endpoint = `${api_base_url}productsearch/search`;

  //query params
  let params = new HttpParams().set('ricerca', `${query}~`);

  if (extra_params) {
    for (const key of Object.keys(extra_params)) {
      params = params.set(key, extra_params[key].toString());
    }
  }

  return this.http.get<Articolo[]>(endpoint, {
    headers: new HttpHeaders(this.account.getHeader()),
    params
  }).pipe(
    catchError((error) => {
      console.error('Errore nella ricerca prodotti:', error);
      return of([]);
    })
  );
}


  private headerColor: string | null = null;  
 
  constructor(private http: HttpClient, private account: AccountService, private storeService: StoreService) {
    console.log("base url", api_base_url);
   }

   get _headers() {
    return {
      headers: new HttpHeaders(this.account.getHeader())
    };
  }

  getFamiglie(): Observable<Famiglia[]> {
      const endpoint = `${api_base_url}productsearch/search/families`;

      return this.http.get<any[]>(endpoint, this._headers).pipe(
        map((response) =>
          response.map((famiglia: any) => ({
            codicefamiglia: famiglia.codice,
            img: famiglia.urlImage,
            descrizione: famiglia.descrizione,
          }))
        ),
        catchError((error) => {
          console.error('Errore nel recupero delle famiglie:', error);
          return of([]);
        })
      );
    }


    getProduct(category: string, extra_params?: { [key: string]: string | number }): Observable<Articolo[]> {
      if (!category) {
        return of([]);
      }
      const endpoint = `${api_base_url}productsearch/search`;
      
      //query params
      let params = new HttpParams().set('famiglia', category);

      if (extra_params) {
        for (const key of Object.keys(extra_params)) {
          params = params.set(key, extra_params[key].toString());
        }
      }

      return this.http.get<Articolo[]>(endpoint, {
        headers: new HttpHeaders(this.account.getHeader()),
        params
      }).pipe(
        catchError((error) => {
          console.error('Errore nel recupero degli articoli per categoria:', error);
          return of([]);
        })
      );
    }

    getProductByCode(codart: string): Observable<ArticoloFull | null> {
      const endpoint = `${api_base_url}Articoli/${codart}`;  
      return this.http.get<ArticoloFull[]>(endpoint, this._headers).pipe(
        map((response) => {
          return response || null;
        }),
        catchError((error) => {
          console.error('Errore nel recupero dell\'articolo:', error);
          return of(null);  
        })
      );
    }
    getAziendaInfo(): Observable<any> {
      const headers = new HttpHeaders({
        ...this.account.getHeader(),
        'Business': this.storeService.azienda_nome_univoco,
      });
  
      const endpoint = `${api_base_url}Azienda/informazioni`;
      return this.http.get<any>(endpoint, { headers }).pipe(
        catchError(error => {
          console.error('Errore nel recupero info azienda:', error);
          return of(null);
        })
      );
    } 
  
  // Metodo per ottenere il colore dell'header direttamente da StoreService
  getHeaderColor(): string | null {
    const config = this.storeService.shopConfig;
    const colorConfig = {
      "header-bg": config["header_bg"],  // Usa il mapping dal StoreService
    };
    return colorConfig["header-bg"] ? '#' + colorConfig["header-bg"] : null; // Restituisci il colore o null
  }

  // Metodo per ottenere il colore accent direttamente da StoreService
  getAccentColor(): string | null {
    const config = this.storeService.shopConfig;
    const colorConfig = {
      "accent-color": config["accent_color"],  // Usa il mapping dal StoreService
    };
    return colorConfig["accent-color"] ? '#' + colorConfig["accent-color"] : null;
  }

  getAccentOppositeColor(): string | null {
    const config = this.storeService.shopConfig;
    const color = config["accent_opposite_color"];
    return color ? '#' + color : null;
  }


}